import { render, staticRenderFns } from "./Percentage.vue?vue&type=template&id=3fd1ac0a&scoped=true&"
import script from "./Percentage.vue?vue&type=script&lang=js&"
export * from "./Percentage.vue?vue&type=script&lang=js&"
import style0 from "./Percentage.vue?vue&type=style&index=0&id=3fd1ac0a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd1ac0a",
  null
  
)

export default component.exports